// extracted by mini-css-extract-plugin
export default {"dmp":"A1bMd61rOK35Fnlv1WQ1"};